import { FC } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  width: 36px;
  height: 36px;
  margin: 20px auto;
  border: 2px #00a0ac solid;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spinner 0.5s infinite linear;

  @keyframes spinner {
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const Spinner: FC<{ isLoading: boolean }> = ({ isLoading }) => {
  return <>{isLoading && <Container />}</>;
};
